import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";
import Logo1 from "../../../images/location_new/caseimg/and-logo-1.webp";
import Img1 from "../../../images/location_new/caseimg/and-case-1.webp";
import Logo2 from "../../../images/location_new/caseimg/and-logo-2.webp";
import Img2 from "../../../images/location_new/caseimg/and-case-2.webp";
import Logo3 from "../../../images/location_new/caseimg/and-logo-3.webp";
import Img3 from "../../../images/location_new/caseimg/and-case-3.webp";
import Logo13 from "../../../images/location_new/caseimg/and-logo-4.webp";
import Img13 from "../../../images/location_new/caseimg/and-case-4.webp";

const CaseStudy = [
  {
    logo: Logo1,
    title: "The Idea Behind Stop Vaping",
    description:
      "Stop Vaping, a digital teen solution, promotes reducing nicotine and e-cigarette use for better health. The app motivates and offers easy paths to a healthier lifestyle.",
    link: "stop-vaping",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img1,
    BgColor: "#66ccc14d",
    TextColor: "#febc5c",
  },
  {
    logo: Logo2,
    title: "The Idea Behind Soundly",
    description:
      "Soundly has transformed the music experience, allowing music enthusiasts to stream millions of songs from emerging artists via the app, offering a new level of musical immersion.",
    link: "soundly",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img2,
    BgColor: "#f79789",
    TextColor: "#ec2125",
  },
  {
    logo: Logo3,
    title: "The Idea Behind Reck’N",
    description:
      "An innovative solution that revolutionizes the restaurant experience, connecting customers and restaurants for seamless booking, enhanced social interaction, and efficient order processing.",
    link: "reck-n-case",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img3,
    BgColor: "#bcbce0",
    TextColor: "#4041AB",
  },
  {
    logo: Logo13,
    title: "The Idea Behind Selah",
    description: "An Interactive Social Platform to Connect Friends and Family",
    link: "saleh",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img13,
    BgColor: "#f3f3f3",
    TextColor: "#000",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2>
                TekRevol’s Success Stories as a Top React Native Development
                Agency in UK
              </h2>
            </div>
            <p className="z_idx">
              Our accomplishments serve as evidence of the proficiency of our
              web and mobile app development services in London. Collaborating
              with enterprises and entrepreneurs across diverse industries, we
              have played a vital role in helping businesses achieve their
              goals. Here are some of the projects we’ve successfully created:
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link ? `/case-studies/${item.link}` : "/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
